module.exports = "<div class=\"loading-overlay\" [class.show]=\"isLoading\">\r\n  <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\r\n</div>\r\n"